<template>
  <div class="main">
    <div
      v-bind:style="{ height: '100px', 'background-color': '#fff' }"
    ></div>
    <HeaderComponent
      :text="$t('text.small_cabin')"
      backgroundColor="#fff"
      textColor="#222"
    />
      
      <div style="width:100%;background-color:#fff;">
        <Transition appear name="fade">
          <div class="menu-container">
          <b-tabs justified pills content-class="mt-3"
            style="color: #000;"
          >
            <b-tab :title="$t('text.information')" @click="tabClicked(0)">
              <div class="info-section">
                <br>
                <div class="info-container">
                  <Transition appear name="fade-short">
                    <p class="info-title">{{ $t('text.the_cabin') }}</p>
                  </Transition>
                  <Transition appear name="fade-long">
                    <p class="info-text">
                      {{ $t('text.s_apartment_text') }} {{ $t('text.located_at') }} <a href="http://maps.google.com/?q=Hjortronvägen 15, 780 91 Sälen" target="_blank">Hjortronvägen 15</a>.
                    </p>
                  </Transition>
                </div>
                <div class="info-container top-margin">
                  <Transition appear name="fade-short">
                    <p class="info-title">{{ $t('text.transport') }}</p>
                  </Transition>
                  <Transition appear name="fade-long">
                    <p class="info-text">
                      {{ $t('text.transport_text') }}
                    </p>
                  </Transition>
                </div>
                <div class="info-container top-margin">
                  <Transition appear name="fade-short">
                    <p class="info-title">{{ $t('text.other') }}</p>
                  </Transition>
                  <Transition appear name="fade-long">
                    <p class="info-text">
                      {{ $t('text.other_text') }}
                    </p>
                  </Transition>
                </div>
              </div>
            </b-tab>
            <b-tab :title="$t('text.images')" lazy @click="tabClicked(1)">
              <br>
              <div class="image-container">
                <CarouselComponent 
                  baseUrl="small_cabin" 
                  fileExtension=".jpg"
                  :amount="9"
                  backgroundColor="transparent"
                />
              </div>
            </b-tab>
            <b-tab :title="$t('text.prices')" lazy @click="tabClicked(2)">
              <br>
              <div v-if="loading_prices" class="loader-container" style="text-align: center; margin-top:30px;margin-bottom:50px;">
                <b-spinner
                  variant="dark"
                  label="Spinning"
                  class="login-loader"
                ></b-spinner>
              </div>
              <div v-if="!loading_prices" class="info-section">
                <b-row>
                  <b-col v-for="cabin_price in cabin_prices" :key="cabin_price.id" class="cabin-info">
                    <p class="info-title">{{ cabin_price.getDisplayName($root.$i18n.locale) }}</p>
                    <p>{{ $t('text.weeks') }}: {{ cabin_price.getCleanedWeekString() }}</p>
                    <br>
                    <p v-if="cabin_price.price_week>0">{{ cabin_price.price_week }}{{ $t('text.sek_sun_to_sun') }}</p>
                    <p v-if="cabin_price.price_sun_to_thur>0">{{ cabin_price.price_sun_to_thur }}{{ $t('text.sek_sun_to_thur') }}</p>
                    <p v-if="cabin_price.price_thur_to_sun>0">{{ cabin_price.price_thur_to_sun }}{{ $t('text.sek_thur_to_sun') }}</p>
                    <p v-if="cabin_price.price_day>0">{{ cabin_price.price_day }}{{ $t('text.sek_per_day') }}</p>
                  </b-col>
                </b-row>      
              </div>
            </b-tab>
          </b-tabs>
        </div>
         
        </Transition>
        
      </div>

      <Transition appear name="fade">
      <div ref="book-button-div" class="book-button-div">
        <button 
          class="book-button yes-button"
          :style="buttonStyle"
          @click="bookButtonPressed()"
        >
            {{ $t('text.book') }}
        </button>
      </div>
    </Transition>

    <ContactComponent/>
  </div>
  
</template>

<script>
import CarouselComponent from "../components/CarouselComponent.vue";
import HeaderComponent from "../components/HeaderComponent.vue";
import ContactComponent from "../components/ContactComponent.vue";
import CabinApiService from "../../services/cabin_api_service";
import CabinPrice from "../../models/cabin_price";

export default {
  name: "LargeCabin",
  components: {
    CarouselComponent,
    HeaderComponent,
    ContactComponent
  },
  data() {
    return {
      buttonPosition: 'fixed',
      buttonScrollOverflow: '25px',
      loading_prices: false,
      cabin_prices: [],
      currentTab: 0,
      buttonStyle: {
        right: '50px',
        position: 'fixed',
        'box-shadow': '0px 0px 30px rgba(0, 0, 0, 0.5)',
        bottom: '50px',
      }
    };
  },
  computed: {
    isLoggedIn() {
      return (
        this.$store.getters.token_valid &&
        this.$store.getters.isLoggedIn
        );
    },
    isFamily() {
      return (
        this.isLoggedIn &&
        this.$store.getters.user.clearance > 0
      );
    },
  },
  methods: {
    handleScroll() {
      //event.preventDefault();
      let bottom = this.$refs["book-button-div"].getBoundingClientRect().bottom;
      if ((this.currentTab === 1) || (bottom <= window.innerHeight - this.buttonScrollOverflow)) {
        this.buttonStyle.position = 'inherit';
        this.buttonStyle['box-shadow'] = '0px 0px 30px rgba(0, 0, 0, 0.0)'
      } else {
        this.buttonStyle.position = 'fixed';
        this.buttonStyle['box-shadow'] = '0px 0px 30px rgba(0, 0, 0, 0.5)'
      }
    },
    onResize() {
      if (window.innerWidth < 980) {
        this.buttonStyle.right = (window.innerWidth/2 - 70) + 'px';
        this.buttonScrollOverflow = -20;
        this.buttonStyle.bottom = '20px'
      } else {
        this.buttonStyle.right = (window.innerWidth/2 - 70) + 'px';
        this.buttonScrollOverflow = 10;
        this.buttonStyle.bottom = '50px'
      }
    },
    tabClicked(tab) {
      this.currentTab = tab;
      setTimeout(()=>{this.handleScroll();}, 10);
    },
    async fetchCabinPrices() {
      this.loading_prices = true;  
      var params = 'cabin=' + (this.isFamily ? '0' : '2')
      try {
        const data = await CabinApiService.get_cabin_prices_full(params);
        this.rows = data.data.count
        this.cabin_prices = data.data.map(dict => {
          return new CabinPrice(dict);
        });
        this.loading_prices = false;
      } catch (error) {
        this.loading_prices = false;
      }
    },
    bookButtonPressed() {
      var query = { cabin: 2};
      if (
        this.$route.query.cabin &&
        this.$route.query.start_date && 
        this.$route.query.end_date
      ) {
        query = this.$route.query
      }
      this.$router.push({ path: '/book', query: query})
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener('resize', this.onResize);
    this.fetchCabinPrices();
  },
  mounted() {
    this.onResize();
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener('resize', this.onResize);
  }
};

</script>

<style scoped>
.main {
  height: 100%;
  width: 100%;
  background-color: #fff;
  text-align: center;
  overflow: visible;
}

.info-section {
  text-align: center;
  max-width: 1000px;
  margin:auto;
  color: #222;
  padding:16px;
}

.info-container {
  text-align: justify;
}

.info-title {
  font-size: 35px;
}

.info-text {
  font-size: 1.1rem;
}

.top-margin {
  margin-top: 30px;
}

.menu-container {
    max-width: 1000px;
    margin:auto;
    padding-right: 16px;
    padding-left: 16px;
}

.book-button {
  text-align: center;
  font-size: 40px;
  color: #fff;
  background-color: #111;

  border: none;
  border-radius: 8px;
  padding: 0px 15px 0px 15px;
  width: 140px;
  z-index: 1000;

  -webkit-transition: box-shadow 0.5s ease-in-out;
  -moz-transition: box-shadow 0.5s ease-in-out;
  -ms-transition: box-shadow 0.5s ease-in-out;
  -o-transition: box-shadow 0.5s ease-in-out;
  transition: box-shadow 0.5s ease-in-out;
}

.book-button:hover {
  background-color: #222;
}

.book-button-div {
  height: 100px;
  margin-top:20px;
}

.info-title {
  font-size: 30px;
  font-weight: normal;
}

.fade-short-enter-active, .fade-short-leave-active {
  transition: opacity 1s;
}

.fade-short-enter, .fade-short-leave-to {
  opacity: 0;
}

.fade-long-enter-active, .fade-long-leave-active {
  transition: opacity 3s;
}

.fade-long-enter, .fade-long-leave-to {
  opacity: 0;
}
</style>

